var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveFclIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0303 11.6289H15.4463V13.9076L21.0303 14.9813V11.6289Z",
    fill: "#C5C9CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0527 7.64062H17.8391V10.8315H13.0527V7.64062Z",
    fill: "#C5C9CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2548 2L11.457 2.03828V13.2246H12.2548V2Z",
    fill: "#C5C9CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0527 13.4473L14.6482 13.7541V11.6289H13.0527V13.4473Z",
    fill: "#C5C9CD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0527 3.65234H14.6482V6.84322H13.0527V3.65234Z",
    fill: "#C5C9CD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06445 3.65234H10.6599V6.84322H9.06445V3.65234Z",
    fill: "#C5C9CD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8562 14.0303L2 15.9256L3.02637 19.2078H20.6861L21.7124 15.9256L11.8562 14.0303Z",
    fill: "#C5C9CD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87305 7.64062H10.6594V10.8315H5.87305V7.64062Z",
    fill: "#C5C9CD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65849 21.2294C3.95122 21.2729 4.22902 21.3857 4.46902 21.5588L4.79202 21.7981C4.98967 21.9295 5.22169 21.9997 5.45905 21.9997C5.69623 21.9997 5.92825 21.9295 6.1259 21.7981L6.44855 21.5588C6.7842 21.3261 7.18286 21.2013 7.59134 21.2013C7.99963 21.2013 8.39831 21.3261 8.73395 21.5588L9.05695 21.7981H9.05713C9.2546 21.9295 9.48644 21.9997 9.72379 21.9997C9.96097 21.9997 10.193 21.9295 10.3905 21.7981L10.7135 21.5588C11.0491 21.3261 11.4478 21.2013 11.8563 21.2013C12.2647 21.2013 12.6634 21.3261 12.999 21.5588L13.3221 21.7981C13.5195 21.9295 13.7515 21.9997 13.9887 21.9997C14.2259 21.9997 14.4579 21.9295 14.6554 21.7981L14.9784 21.5588H14.9786C15.3142 21.3261 15.7129 21.2015 16.1212 21.2015C16.5296 21.2015 16.9283 21.3261 17.264 21.5588L17.5866 21.7981C17.7843 21.9295 18.0163 21.9997 18.2535 21.9997C18.4908 21.9997 18.7228 21.9295 18.9205 21.7981L19.2435 21.5588C19.4832 21.3854 19.7613 21.2725 20.054 21.2294L20.4369 20.0049H3.27539L3.65849 21.2294Z",
    fill: "#C5C9CD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26666 11.6289H2.68262V14.9813L8.26666 13.9076V11.6289Z",
    fill: "#C5C9CD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6599 13.4473V11.6289H9.06445V13.7541L10.6599 13.4473Z",
    fill: "#C5C9CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveFclIcon);
export default __webpack_public_path__ + "static/media/inactive-fcl-icon.17fed7a7c74b31197692e913e7f6f6fa.svg";
export { ForwardRef as ReactComponent };